import styled from "styled-components";
import {
  breakpoint,
  space,
} from "shared/styles/constants";

export const StyledCalendarTools = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;

  ${breakpoint("s", "down")} {
    flex-direction: column;

    > * + * {
      margin-top: ${space.s};
    }
  }
`;
